export const FETCH_PARKED = "[MRT] FETCH_PARKED";
export const FETCH_PARKED_START = "[MRT] FETCH_PARKED_START";
export const FETCH_PARKED_SUCCESS = "[MRT] FETCH_PARKED_SUCCESS";
export const FETCH_PARKED_ERROR = "[MRT] FETCH_PARKED_ERROR";

export const SET_PARKED_FILTER = "[MRT] SET_PARKED_FILTER";
export const SET_PARKED_PAGINATION = "[MRT] SET_PARKED_PAGINATION";

export const VIEW_PARKED_VISIT_LOADING_START = "[MRT] VIEW_PARKED_VISIT_LOADING_START";
export const VIEW_PARKED_VISIT_LOADING_END = "[MRT] VIEW_PARKED_VISIT_LOADING_END";
export const RESET_PARKED_FILTER = "[MRT] RESET_PARKED_FILTER";
export const SET_PARKED_AUTO_NEXT_VISIT = "[MRT] SET_PARKED_AUTO_NEXT_VISIT";

export const fetchMrtParked = (payload) => {
    return {
        type: FETCH_PARKED,
        payload
    };
};

export const setMrtParkedFilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_PARKED_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const resetParkedFilter = () => {
    return {
        type: RESET_PARKED_FILTER,
    };
}

export const setParkedAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_PARKED_AUTO_NEXT_VISIT,
        autoNextVisit
    };
}
